import { PRICING } from '../../config/pricingConfig';

const CheckIcon = () => (
  <svg
    className="mx-auto h-5 w-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 13l4 4L19 7"
    />
  </svg>
);

export const ComparisonTable = () => (
  <div className="mt-8 w-full max-w-6xl sm:mt-12">
    <h2
      className={`
        mb-6 text-left font-[Outfit] text-2xl font-light text-[#0d0d0d]
        sm:mb-8 sm:text-3xl
      `}
    >
      Compare Plans
    </h2>
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-left">
        <caption className="sr-only">
          Feature comparison across Free, Starter, and Pro plans
        </caption>
        <thead>
          <tr className="border-b-2 border-gray-200">
            <th
              className={`
                px-4 py-3 text-sm font-semibold text-gray-500
                sm:text-base
              `}
            >
              Feature
            </th>
            <th className="px-4 py-3 text-center">
              <span
                className={`
                  inline-block rounded bg-white px-2 py-1 text-sm font-medium
                  text-black
                  sm:text-base
                `}
              >
                Free
              </span>
            </th>
            <th className="px-4 py-3 text-center">
              <span
                className={`
                  inline-block rounded bg-[#f3f4f4] px-2 py-1 text-sm
                  font-medium text-black
                  sm:text-base
                `}
              >
                Starter
              </span>
            </th>
            <th className="px-4 py-3 text-center">
              <span
                className={`
                  inline-block rounded bg-[#fdf4bf] px-2 py-1 text-sm
                  font-medium text-black
                  sm:text-base
                `}
              >
                Pro
              </span>
            </th>
          </tr>
        </thead>
        <tbody className="text-sm sm:text-base">
          <tr className="border-b border-gray-100 bg-gray-50">
            <td className="px-4 py-3 font-medium text-gray-700">
              Monthly Billing Price
            </td>
            <td className="px-4 py-3 text-center text-gray-600">$0/mo</td>
            <td className="px-4 py-3 text-center text-gray-600">
              ${PRICING.starter.monthly}/mo
            </td>
            <td className={`px-4 py-3 text-center font-medium text-gray-800`}>
              ${PRICING.pro.monthly}/mo
            </td>
          </tr>
          <tr className="border-b border-gray-100">
            <td className="px-4 py-3 font-medium text-gray-700">
              Annual Billing Price
            </td>
            <td className="px-4 py-3 text-center text-gray-600">$0/mo</td>
            <td className="px-4 py-3 text-center text-gray-600">
              <span>
                ${PRICING.starter.monthly * (1 - PRICING.annualDiscount)}
                /mo
              </span>
              <span className="block text-xs text-gray-400">
                (${PRICING.starter.annual}/yr)
              </span>
            </td>
            <td className={`px-4 py-3 text-center font-medium text-gray-800`}>
              <span>
                ${PRICING.pro.monthly * (1 - PRICING.annualDiscount)}/mo
              </span>
              <span className="block text-xs text-gray-500">
                (${PRICING.pro.annual}/yr)
              </span>
            </td>
          </tr>
          <tr className="border-b border-gray-100 bg-gray-50">
            <td className="px-4 py-3 font-medium text-gray-700">
              Monthly Credits
            </td>
            <td className="px-4 py-3 text-center text-gray-400">0</td>
            <td className="px-4 py-3 text-center text-gray-600">
              {PRICING.starter.credits}
            </td>
            <td className={`px-4 py-3 text-center font-medium text-gray-800`}>
              {PRICING.pro.credits}
            </td>
          </tr>
          <tr className="border-b border-gray-100">
            <td className="px-4 py-3 font-medium text-gray-700">Projects</td>
            <td className="px-4 py-3 text-center text-gray-600">Up to 3</td>
            <td className="px-4 py-3 text-center text-gray-600">Unlimited</td>
            <td className={`px-4 py-3 text-center font-medium text-gray-800`}>
              Unlimited
            </td>
          </tr>
          <tr className="border-b border-gray-100 bg-gray-50">
            <td className="px-4 py-3 font-medium text-gray-700">
              PDF or image systems
            </td>
            <td className="px-4 py-3 text-center text-gray-600">Up to 3</td>
            <td className="px-4 py-3 text-center text-gray-600">Up to 50</td>
            <td className={`px-4 py-3 text-center font-medium text-gray-800`}>
              Up to 50
            </td>
          </tr>
          <tr className="border-b border-gray-100">
            <td className="px-4 py-3 font-medium text-gray-700">
              MusicXML Measures
            </td>
            <td className="px-4 py-3 text-center text-gray-600">Up to 18</td>
            <td className="px-4 py-3 text-center text-gray-600">Up to 300</td>
            <td className={`px-4 py-3 text-center font-medium text-gray-800`}>
              Up to 300
            </td>
          </tr>
          <tr className="border-b border-gray-100 bg-gray-50">
            <td className="px-4 py-3 font-medium text-gray-700">
              Credit Packs
            </td>
            <td className="px-4 py-3 text-center text-green-600">
              <CheckIcon />
            </td>
            <td className="px-4 py-3 text-center text-green-600">
              <CheckIcon />
            </td>
            <td className="px-4 py-3 text-center text-green-600">
              <CheckIcon />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);
